import { IRecoverEmailApi } from "../interface/IForgotEmail";

interface IVerificationCodePayload {
    otpCode: string;
    mobileNumber: string;
    brand: string;
}

export const getStateToPayload = (
    verificationCode: string,
    mobileNumber: string,
    brand: string
): IVerificationCodePayload => ({
    otpCode: verificationCode,
    mobileNumber,
    brand,
});

export interface IRecoverEmailApiResponse {
    email: string;
    verified: boolean;
    validOtp: boolean;
}

export const getResponseToState = (response: IRecoverEmailApiResponse): IRecoverEmailApi => ({
    email: response.email,
    isVerified: response.verified,
    validOtp: response.validOtp,
});
